/* @flow */
import * as React from 'react';

import styles from './styles.module.scss';

type Props = {
  title?: string,
  label?: string,
  multiline?: boolean,
  meta?: any,
};

const InputText = (props: Props): React$Element<any> => {
  const { label, title, multiline, meta, ...rest } = props;
  return (
    <label className={styles.container}>
      {label ? <div className={styles.label}>{label}</div> : null}
      {multiline ? (
        <textarea
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          className={styles.input}
          title={title || (typeof label === 'string' ? label : undefined)}
          {...rest}
        />
      ) : (
        <input
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          className={styles.input}
          title={title || label}
          {...rest}
        />
      )}
    </label>
  );
};

export default InputText;
